import './HighlighterHOC.css';
import Highlighter from 'react-highlight-words';
import React from 'react';
const getFilteredItem = item => {
  const specialSymbols = ["*", "?", "(", ")", "[", "]", "{", "}", "+", "\\"];
  const copyItem = item.slice();
  const isSpecialSymbolExist = specialSymbols.some(symbol => copyItem.includes(symbol));
  if (isSpecialSymbolExist) {
    return copyItem.split("").map(letter => {
      const isLetterSpecialSymbol = specialSymbols.some(symbol => letter.includes(symbol));
      if (isLetterSpecialSymbol) {
        return `\\${letter}`;
      }
      return letter;
    }).join("");
  }
  return copyItem;
};
export const HighlighterHOC = _ref => {
  let {
    searchString,
    text
  } = _ref;
  if (typeof searchString === 'string') {
    const filteredSearchString = getFilteredItem(searchString);
    return /*#__PURE__*/React.createElement("div", {
      className: `${commonStyles}`
    }, /*#__PURE__*/React.createElement(Highlighter, {
      highlightClassName: "marked",
      searchWords: [filteredSearchString],
      textToHighlight: text
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, text);
};
export const commonStyles = "c88h133";